<template>
    <div class="rank-list mt10">
        <div v-if="tableData.length === 0">
            <p v-if="!searchFail" class="color99 font16 dfcjc">
                <i class="iconfont-npm icon-npm-jinggaotishi1 mr10" style="font-size: 30px; color: #ccc"></i
                >请输入关键词进行查询
            </p>
            <div v-else class="dfcjc search-fail" style="align-items: flex-start">
                <i class="iconfont-npm icon-npm-jinggaotishi1 mr10" style="font-size: 30px; color: #ff9000"></i>
                <div class="ml10">
                    <p>
                        在第 <em style="color: #ff9000">{{ pageRange[0] }}</em> 至第
                        <em style="color: #ff9000">{{ pageRange[1] }}</em>
                        <span>{{ port === 0 ? ' 页' : ' 个' }}</span
                        >，此关键词，未搜索到当前产品信息
                    </p>
                    <template v-if="linkToAnalysis">
                        <p>建议您：</p>
                        <p>
                            1 . 查看<a href="javascript:void(0);" style="color: #2b97d9" @click="suggest">优化建议</a
                            >，提升产品质量，获得更多曝光！
                        </p>
                    </template>
                </div>
            </div>
        </div>
        <div v-else>
            <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="tableHeader">
                <el-table-column label="关键词" align="center" header-align="center" width="100">
                    <template #default="{ row }">
                        <span class="textOver" :title="row.keyword">{{ row.keyword }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="" align="center" header-align="center" width="84">
                    <template #default="{ row }">
                        <a
                            style="width: 64px"
                            :href="`https://detail.1688.com/offer/${row.ProductInfo.ProductId}.html?token=${token}`"
                            target="_blank"
                            ><img
                                style="max-width: 64px; max-height: 64px"
                                :src="`https://cbu01.alicdn.com/${row.ProductInfo.Image.images[0]}`"
                        /></a>
                    </template>
                </el-table-column>
                <el-table-column label="产品信息" header-align="center">
                    <template #default="{ row }">
                        <a
                            style="display: block"
                            :href="`https://detail.1688.com/offer/${row.ProductInfo.ProductId}.html?token=${token}`"
                            target="_blank"
                            v-html="row.title"
                        />
                        <div>
                            <span>更新时间：{{ row.LastUpdateTime.substring(0, 10) }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="产品星级" align="center" header-align="center" width="190">
                    <template #default="{ row }">
                        <el-rate
                            v-model="row.ProductInfo.QualityLevel"
                            :max="7"
                            disabled
                            text-color="#ff9900"
                            score-template="{value}"
                        />
                    </template>
                </el-table-column>
                <el-table-column label="企业实力" align="center" header-align="center" width="115">
                    <template #default="{ row }">
                        <img
                            v-if="row.shilitag"
                            :src="`${domain}tools/dzPopup/icon/strengthIcon.png`"
                            style="vertical-align: middle"
                        /><img
                            :src="`${domain}tools/dzPopup/icon/chengIcon.png`"
                            class="ml5"
                            style="vertical-align: middle"
                        />{{ row.companyTag }}
                    </template>
                </el-table-column>
                <el-table-column
                    :label="port === 0 ? '90天成交量' : '90天成交额'"
                    align="center"
                    header-align="center"
                    width="95"
                    prop="tradeBt"
                />
                <el-table-column label="类型" align="center" header-align="center" width="80" prop="type" />
                <el-table-column label="排名位置" align="center" header-align="center" width="115">
                    <template #default="{ row }">
                        <!-- <p v-if="port === 0">
                            <span
                                >第<em style="color: #ff9000">{{ row.pageIndex }}</em
                                >页 第<em style="color: #ff9000">{{ row.rank }}</em
                                >条</span
                            >
                        </p> -->
                        <p>
                            第<em style="color: #ff9000">{{ row.pageIndex }}</em
                            >个
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" header-align="center" width="90">
                    <template #default="{ row }">
                        <el-button v-if="linkToAnalysis" type="text" @click="goToLink(row)">点击分析</el-button>
                        <!-- <a
                            v-if="port === 0"
                            style="display: block; color: #1e71b1"
                            :href="row.detailUrl"
                            target="_blank"
                            >点击查看</a
                        > -->
                    </template>
                </el-table-column>
            </el-table>
            <div v-if="showPagination" class="tc mt10">
                <el-pagination
                    :current-page="query.index"
                    :page-size="query.size"
                    background
                    layout="prev, pager, next,total, jumper"
                    :total="query.total"
                    @current-change="handleCurrentChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import config from '@packages/common/config.js';
export default {
    name: 'RankList',
    props: {
        tableData: {
            type: Array,
            default() {
                return [];
            },
        },

        query: {
            type: Object,
            default: () => ({
                index: 1,
                size: 10,
                total: 0,
            }),
        },
        showPagination: {
            type: Boolean,
            default: false,
        },
        linkToAnalysis: {
            type: Boolean,
            default: true,
        },
        isUseNew: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            token: '',
            tableHeader: {
                background: '#f4f4f4',
                color: '#4c4b4b',
                fontSize: '14px',
                fontWeight: 'normal',
            },
            domain: config.ossUiDomainUrl,
            searchFail: false,
            pageRange: [],
            port: 1, // 0:"PC端", 1:"移动端"
            // tempPageRange: [],
        };
    },
    created() {
        // 目前 商机助理，排名优化_排名查询_竞品分析，大泽云ERP智慧版(档口)，店长工具，慧眼识货标准版 在用
        this.token = localStorage.getItem('accessToken') || localStorage.getItem('sjzlAccessToken');
        this.domainHost = location.hostname === 'localhost' ? 'https://test.fjdaze.com' : '';
    },
    methods: {
        handleCurrentChange(index) {
            this.$emit('pageChange', index);
        },
        suggest() {
            // 排名优化_排名查询_竞品分析，，
            const host = location.host;
            if (host === 'ai.fjdaze.com') {
                // 慧眼识货标准版
                window.open(`${this.domainHost}/SmartEye?page=btyh`, '_blank');
            } else if (host === 'erp.fjdaze.com' || host === 'erppc.fjdaze.com') {
                // 大泽云ERP智慧版(档口)
                this.$router.push('/cpzd');
            } else {
                window.open(`${this.domainHost}/to?token=${this.token}`, '_blank');
            }
        },
        // searchFailFn() {
        //   this.searchFail = true;
        //   // this.pageRange = cloneDeep(this.tempPageRange);
        // },

        goToLink(row) {
            if (this.isUseNew) {
                this.$router.push({
                    path: this.productAnalysisPath,
                    query: {
                        offerId: row.ProductInfo.ProductId,
                    },
                });
                return;
            }
            window.open(`${this.domainHost}/ca/product?offerId=${row.ProductInfo.ProductId}&token=${this.token}`);
        },
    },
};
</script>

<style lang="scss" scoped>
.rank-list {
    background: #fff;
    padding: 45px 20px 25px;
    .search-fail {
        i {
            margin-top: 5px;
        }
        color: #7e7e7e;
        font-size: 14px;
        line-height: 1.5em;
    }
}
</style>
